$(document).ready(function() {
  // Función para activar el filtro según la URL al cargar la página
  function setActiveFilterFromURL() {
    var currentUrl = window.location.pathname;

    // Establecer los filtros activos según la URL
    if (currentUrl.includes('/cursos-nuevos')) {
      $('.filter-btn').removeClass('active');
      $('.filter-btn[data-filter="new-courses"]').addClass('active');
      $('#category-filters').show(); // Mostrar filtros de categoría
      $('#modalidad-filters').hide(); // Ocultar filtros de modalidad
      $('#category-dropdown-collection').show(); // Mostrar dropdown de categorías
      $('#modalidad-dropdown-collection').hide(); // Ocultar dropdown de modalidad
      $('#fil-mod').hide();
    } else if (currentUrl.includes('/cursos-en-oferta')) {
      $('.filter-btn').removeClass('active');
      $('.filter-btn[data-filter="offer-courses"]').addClass('active');
      $('#category-filters').show(); // Mostrar filtros de categoría
      $('#modalidad-filters').hide(); // Ocultar filtros de modalidad
      $('#category-dropdown-collection').show(); // Mostrar dropdown de categorías
      $('#modalidad-dropdown-collection').hide(); // Ocultar dropdown de modalidad
      $('#fil-mod').hide();
    } else if (currentUrl.includes('/cursos-por-modalidad')) {
      $('.filter-btn').removeClass('active');
      $('.filter-btn[data-filter="modalidad"]').addClass('active');
      $('#category-filters').hide(); // Ocultar filtros de categoría
      $('#modalidad-filters').show(); // Mostrar filtros de modalidad
      $('#category-dropdown-collection').hide(); // Ocultar dropdown de categorías
      $('#modalidad-dropdown-collection').show(); // Mostrar dropdown de modalidad
      $('#fil-cat').hide();
    } else if (currentUrl.includes('/all')){
      $('#modalidad-dropdown-collection').hide();
      $('#fil-mod').hide();
    }
  }

  // Llamada a la función de activación al cargar la página
  setActiveFilterFromURL();
  
  // Cambiar el estado de los botones de filtro y redirigir al hacer clic
  $('.filter-btn').click(function() {
    var filter = $(this).data('filter');

    // Cambiar estado de los botones de filtro
    $('.filter-btn').removeClass('active');
    $(this).addClass('active');

    // Redirigir y ajustar visibilidad de los filtros
    if (filter === 'all') {
      window.location.href = '/collections/all';
    } else if (filter === 'new-courses') {
      window.location.href = '/collections/cursos-nuevos';
    } else if (filter === 'offer-courses') {
      window.location.href = '/collections/cursos-en-oferta';
    } else if (filter === 'modalidad') {
      window.location.href = '/collections/cursos-por-modalidad';
    }
  });

  // Funcionalidad para los filtros de categoría
  $('.category-checkbox').change(function() {
    var selectedCategories = [];
    $('.category-checkbox:checked').each(function() {
      selectedCategories.push($(this).data('category'));
    });

    if (selectedCategories.length === 0) {
      location.reload();  // Recarga la página si no hay categorías seleccionadas
    } else {
      filterProductsByCategory(selectedCategories);
    }
  });

  // Filtrar productos por categoría
  function filterProductsByCategory(categories) {
    $('.product-grid .grid__item').each(function() {
      var productCategories = $(this).data('category').split(' ');

      if (categories.some(category => productCategories.includes(category))) {
        $(this).css('display', 'block'); // Aseguramos que el producto se muestre
      } else {
        $(this).css('display', 'none'); // Ocultar producto
      }
    });
  }

  // Función para aplicar el filtro por defecto basado en la URL
  function applyDefaultFilter() {
    var currentUrl = window.location.pathname;
    var defaultTag = '';

    if (currentUrl.includes('/cursos-nuevos')) {
      defaultTag = 'cursos-nuevos';
    } else if (currentUrl.includes('/cursos-en-oferta')) {
      defaultTag = 'cursos-oferta';
    } else if (currentUrl.includes('/cursos-por-modalidad')) {
      defaultTag = 'cursos-modalidad';
    }
    filterProductsByCategory([defaultTag]);
  }

  // Funcionalidad para los dropdowns de filtros (mobile)
  $('#category-dropdown-collection').change(function() {
    var selectedCategory = $(this).val();
    filterProductsByCategory([selectedCategory]);
  });

  $('#modalidad-dropdown-collection').change(function() {
    var selectedModalidad = $(this).val();
    filterProductsByCategory([selectedModalidad]);
  });

  // **Responsive: Mostrar los filtros correctos en mobile**
  $(window).resize(function() {
    if ($(window).width() <= 1024) {  // Si la pantalla es más pequeña o igual a 1024px
      $('.collection-filters-mobile').show(); // Mostrar el diseño mobile
      $('.collection-filters').hide(); // Ocultar el diseño para desktop
    } else {
      $('.collection-filters').show(); // Mostrar el diseño desktop
      $('.collection-filters-mobile').hide(); // Ocultar el diseño mobile
    }
  });

  // Llamada para mostrar los filtros correctos según el tamaño de la pantalla al cargar
  $(window).trigger('resize');
});

